<template>
    <v-container fluid>
        <PublicDocumentModal @modalClosed=""/>
        <v-row>
            <v-col cols="12">
                <DataTable
                    :headers="headers"
                    :items="gazettes"
                    module="Gazette"
                    model="gazettes"
                    @handlePageChanged="getGazettes"
                    @handleOldDocument="loadOldDocument"
                    sort-by="created_at"
                    group-by="document_id"
                    group-label="document_title"
                    item-key="id"
                    class="elevation-1"
                    show-group-by
                >
                    <template #top>
<!--                        <TableTopToolbar-->
<!--                            entity="Közlöny"-->
<!--                            title="Közlöny"-->
<!--                            model="gazettes"-->
<!--                        />-->
                    </template>
                </DataTable>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import DataTable from "../../components/Table/DataTable";
import PublicDocumentModal from '../Documents/Modals/PublicDocumentModal'
import TableTopToolbar from '../../components/Table/TopToolbar/TableTopToolbar'
import {SET_ACTIVITY, SET_DOCUMENT, SET_ITEM, SET_SHOW_MODAL} from "../../utils/constants";

export default {
    name: "GazettesList",
    components: {DataTable, PublicDocumentModal, TableTopToolbar},
    computed: {
        ...mapGetters("Gazette", ["gazettes", "headers"]),
        ...mapGetters("Activity", ["activity"]),
    },
    mounted() {
        this.getGazettes();
    },
    methods: {
        ...mapActions("Gazette", ["getGazettes", "loadOldDocument"]),
        ...mapActions("Activity", ["getActivityById"]),
        ...mapMutations("Modal", [SET_SHOW_MODAL, SET_ITEM]),
        ...mapMutations("Document", [SET_DOCUMENT]),
    }
};
</script>

<style></style>
